import React from 'react';
import { isEmpty } from 'lodash';
import { linkResolver } from 'utils/linkResolver';

import { PrismicRichText, IPrismicRichText } from 'types/prismicRichtext';
import { PrismicLink } from 'types/prismicLink';
import { PrismicImage } from 'types/prismicImage';

import { Cta } from 'components/cta/Cta';
import { asText, RichText } from 'components/rich-text/RichText';

import { ImageContainer } from './ImageContainer';

interface ICtaContainerProps {
  heading?: PrismicRichText;
  text?: PrismicRichText;
  link: PrismicLink;
  linkText?: PrismicRichText;
  isColumnLayout?: boolean;
  image?: PrismicImage;
}

export const CtaContainer = ({
  heading,
  text,
  link,
  linkText,
  image,
  isColumnLayout,
}: ICtaContainerProps) => {
  if (isEmpty(heading) && isEmpty(text) && isEmpty(linkText)) {
    return null;
  }

  return (
    <Cta
      heading={heading ? asText(heading) : undefined}
      isColumnLayout={isColumnLayout}
      linkText={linkText ? asText(linkText as IPrismicRichText) : undefined}
      to={linkResolver(link)}
      image={image ? <ImageContainer image={image} imageOnly /> : undefined}
    >
      {text && <RichText>{text}</RichText>}
    </Cta>
  );
};
